import ErrorMessage from '../ErrorMessage';

export default class CameraAndMicPermissionDeniedError extends Error {
  name = ErrorMessage.CAMERA_AND_MIC_PERMISSION_DENIED;
}
